// extracted by mini-css-extract-plugin
export var largeOnly = "styles-module--largeOnly--3xXKs";
export var mediumAndDown = "styles-module--mediumAndDown--1efxm";
export var mediumAndUp = "styles-module--mediumAndUp--2pOgw";
export var responsive = "styles-module--responsive--2gbic";
export var smallOnly = "styles-module--smallOnly--13PEM";